<template>
	<section class="hero is-fullheight"  v-if="isConnected">
		<div class="hero-body">
			<div class="container">
				<div class="columns is-centered">
					<div class="column is-5-tablet is-4-desktop is-3-widescreen has-text-centered">
						<Logo/>
						<template>
							<template v-for="appli in allApplis">

								<div class="box" >
									<form method="get" :action="appli.url" ref="go">
										<input type="hidden" :value="$store.state.jwt" name="jwt">
										<h2 class="title is-5">{{appli.title}}</h2>
										<h3 class="subtitle is-6">{{appli.desc}}</h3>
										<template v-if="appli.slug == $store.state.appli">
											<button class="button is-warning" type="submit" :class="{'is-loading' : loading}" @click="loading=true">Ouvrir cette application</button>
										</template>
										<template v-else>
											<button type="submit" class="invisible"></button>
										</template>
									</form>
								</div>
							</template>	
							<p><button class="button is-text is-small" @click="logOut">Se déconnecter</button></p>
						</template>	
					</div>
				</div>
			</div>
		</div>
	</section>	

</template>

<script>

	export default {
		name: 'Home',
		data() {
			return {
				loading:false,
				jwt:false,
				url:false

			}
		},
		mounted() {
			setTimeout(() => {
				if(this.appliCourante && !this.loading) {
					this.loading=true;

					setTimeout(() => {
						let go = this.$refs.go[0];
						if(!process.env.VUE_APP_REDIR) {
							go.submit()
						}
					},1000);
				}
			},1000)
		},
		computed : {
			allApplis() {
				let out = [];
				for(const key in this.applis) {
					const appli = this.applis[key];
					if(appli.slug == this.$route.query.appli || !this.$route.query.appli) {
						out.push(appli);
					}				
				}
				return out;
			}
		},
		methods : {
			// seConnecter(appli) {
			// 	this.url = appli.url;
			// 	axios.get('jwt').then(response =>  {
			// 		this.jwt = response.data.jwt;
			// 		if(this.jwt) {
			// 			this.$refs.postForm.submit();
			// 		}
			// 	});
			// }
		}
	}
</script>
<style lang="scss">
.box {
	position: relative;
	button.invisible {
		cursor: pointer;
		opacity: 0;
		position: absolute;
		top:0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		background-color: #fee100;
		border:none;
		&:hover {
			opacity: .1;
		}
	}
}
</style>